import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-menu_more",
  "use": "icon-menu_more-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 24 24\" id=\"icon-menu_more\">\n    <path fill=\"#86898B\" d=\"M3 5.99c0-.547.443-.99.99-.99h16.02c.547 0 .99.443.99.99 0 .546-.443.989-.99.989H3.99c-.547 0-.99-.443-.99-.99zM3 12.001c0-.546.443-.99.99-.99h16.02c.547 0 .99.444.99.99s-.443.99-.99.99H3.99c-.547 0-.99-.444-.99-.99zM3 18.009c0-.547.443-.99.99-.99h16.02c.547 0 .99.444.99.99s-.443.99-.99.99H3.99c-.547 0-.99-.444-.99-.99z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol